
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq0DplRfm5E27NRfOB08R2OneNK5m4wDXWhLLxlVgCdJUMeta } from "D:/projects/taminify_com-front/pages/faq.vue?macro=true";
import { default as aboutCHpRmaSGn4pgA6aQ_5Vvi7Y_45G_45mHr0CVzlXeQHo_45_45tEMeta } from "D:/projects/taminify_com-front/pages/about.vue?macro=true";
import { default as index8pkQesfXpZbfMo_45eZiBFLpXzGGR4GMDU_9tgdQxFTFIMeta } from "D:/projects/taminify_com-front/pages/index.vue?macro=true";
import { default as termsZtcP6_b4VyoEYiOg9zfmdtvOUL0YObCPOpHeCuj0zOAMeta } from "D:/projects/taminify_com-front/pages/terms.vue?macro=true";
import { default as indexkVz6G2_B3v9XODpnYVR_45lk4ZemsEwiFlU_tXDX_YWAMMeta } from "D:/projects/taminify_com-front/pages/blog/index.vue?macro=true";
import { default as _91slug_93eTcZHo2fnaWD7gXsbCETc8xKOYVjrH_Zcg_45WWzLD_2MMeta } from "D:/projects/taminify_com-front/pages/blog/[slug].vue?macro=true";
import { default as indexC9ls9XsVXN52pEbk6ODr6zKZNK0sj_456_1FSKd4auRzMMeta } from "D:/projects/taminify_com-front/pages/panel/index.vue?macro=true";
import { default as logine5A7bjdUEHTETAukR7SxsXc4reJ2FLYvqD8NFI_452T7EMeta } from "D:/projects/taminify_com-front/pages/(auth)/login.vue?macro=true";
import { default as cart5fwXJ7aNr6CEJptyidVyU8gur5wmC0YEMe0KW8vvceEMeta } from "D:/projects/taminify_com-front/pages/(store)/cart.vue?macro=true";
import { default as register2kE1NBG8ctXeKdZ_0nRSsrXnx_459m9DwKRwmhrHYTpTcMeta } from "D:/projects/taminify_com-front/pages/(auth)/register.vue?macro=true";
import { default as checkoutznReYaSU_45fQ2VM1bgJiaxyERfTHJulXJk9wU0fi1BGgMeta } from "D:/projects/taminify_com-front/pages/(store)/checkout.vue?macro=true";
import { default as trackingUJaGB4pYT3Sc3rMSo14wg3pH_45yG32zQL37Op_45_45OXQScMeta } from "D:/projects/taminify_com-front/pages/(store)/tracking.vue?macro=true";
import { default as indexf9fpHsgXZ5PRol25yuadlrlv2BB7icNSY2nZjPzFI4wMeta } from "D:/projects/taminify_com-front/pages/panel/apps/index.vue?macro=true";
import { default as callbackOwBs2WJLODmTyu3nOhfgbuGU1O0G_072_45Tjl4ZGgSisMeta } from "D:/projects/taminify_com-front/pages/payment/callback.vue?macro=true";
import { default as index1LnX7X3lhJoqiZE2n2xeL_45iEyFqfq7sSIAElZ2uBr_454Meta } from "D:/projects/taminify_com-front/pages/panel/admin/index.vue?macro=true";
import { default as cartymIRBQSDs7i2yUc5jDFk8k5OCPqKuNXaYCXsN6TPI78Meta } from "D:/projects/taminify_com-front/pages/@[store_slug]/cart.vue?macro=true";
import { default as about1Q4PUStxJVQxjDdepPiTq6aAsFpGdF97iz0AWyUwLXQMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/about.vue?macro=true";
import { default as indexRkL_jpOdPSzhB0t48Ma0R2a8jhpMvHAqf2rUKYYeYKUMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/index.vue?macro=true";
import { default as indexlQKb341oLAiGdUqU9vZsUr_45KmElhrV3FD7zWi4RO8sUMeta } from "D:/projects/taminify_com-front/pages/panel/parcels/index.vue?macro=true";
import { default as index3DgwtIj05NjOOLNvy2UWOr0PqdHhhiX7WfuCKCh_45QIcMeta } from "D:/projects/taminify_com-front/pages/panel/products/index.vue?macro=true";
import { default as indexeNel3I9EAFbXWygIGXPunLAt7EabrPs3eRcGV863eFUMeta } from "D:/projects/taminify_com-front/pages/panel/settings/index.vue?macro=true";
import { default as indexhTqy4pAset4r9k4k_agRPdIqMccRHF4y_459DvLCzar1sMeta } from "D:/projects/taminify_com-front/pages/panel/financial/index.vue?macro=true";
import { default as createFshUBTYuNobxQHlRYFBjti8zjc_45R1XyPXzKTymS7jvMMeta } from "D:/projects/taminify_com-front/pages/panel/products/create.vue?macro=true";
import { default as checkout7PJyPYVdGgHPtmHjPOF6w4R1GRAUd2nreMZPWx7KatsMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/checkout.vue?macro=true";
import { default as trackingbcwMEGXBbCwBqgKQ_45re59WBvPGcqhwBjuBg28_45lZOmsMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/tracking.vue?macro=true";
import { default as indexzU7mXyDuFAyUG5a_uj3RFdBdXQNXSKdZqNCA_Rrio5UMeta } from "D:/projects/taminify_com-front/pages/panel/admin/users/index.vue?macro=true";
import { default as index6sTidBAFWYmUx0fk58WsyRXnlxUOmIIraDZcIhAVvCUMeta } from "D:/projects/taminify_com-front/pages/(store)/categories/index.vue?macro=true";
import { default as edit18y4TUANn76i_45L5dt17SiC9wReVbXX_450L57CJbGNghcMeta } from "D:/projects/taminify_com-front/pages/panel/products/[id]/edit.vue?macro=true";
import { default as index6Eu_45d1WFjPWtC4Wb_s1zxolg4Uho2K30XOoPtxNmrcwMeta } from "D:/projects/taminify_com-front/pages/panel/admin/products/index.vue?macro=true";
import { default as tracking_45by_45idH3Krkf62gmeNafZB98eRY46MJGJv3b_aFGeenv7ncI8Meta } from "D:/projects/taminify_com-front/pages/@[store_slug]/tracking-by-id.vue?macro=true";
import { default as _91product_id_93g1FxPjKuIGC699KMXIJblDxr9dP3sEWEfnOikMIgV2gMeta } from "D:/projects/taminify_com-front/pages/(store)/products/[product_id].vue?macro=true";
import { default as indexZShFXiCNBXpZpon3rX_45uAWlfRdoEHEyB4RSGOtVdM0cMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/categories/index.vue?macro=true";
import { default as edit_45bzGr5b4f_J6rDJ_454JHjHPObn_ORyEUh7yzmCZ4u0ygMeta } from "D:/projects/taminify_com-front/pages/panel/admin/products/[id]/edit.vue?macro=true";
import { default as _91category_slug_93mO6DIST_eafMIfy6ijPmBUrXLvmsNCn5_NKSmvj_K6MMeta } from "D:/projects/taminify_com-front/pages/(store)/categories/[category_slug].vue?macro=true";
import { default as _91product_id_9320fcrgbmZm3U2JV6RUIMxRzi1IstE6BU_GZthFmnDosMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/products/[product_id].vue?macro=true";
import { default as indexrOlG6o0VmHBxBemN1oyFiVcTZvOhsPbXc729O60AAygMeta } from "D:/projects/taminify_com-front/pages/panel/admin/withdraw-requests/index.vue?macro=true";
import { default as _91category_slug_93F9HXGA_veT_BK8JnOHqXK3J_qplElyuHsIX_45eSzunRYMeta } from "D:/projects/taminify_com-front/pages/@[store_slug]/categories/[category_slug].vue?macro=true";
import { default as component_45stubtwoC70oqQBff71ecTajfXw3oAHpyDCPqKtTCWBCKAxQMeta } from "D:/projects/taminify_com-front/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubtwoC70oqQBff71ecTajfXw3oAHpyDCPqKtTCWBCKAxQ } from "D:/projects/taminify_com-front/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "landing.faq",
    path: "/faq",
    meta: faq0DplRfm5E27NRfOB08R2OneNK5m4wDXWhLLxlVgCdJUMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/faq.vue")
  },
  {
    name: "landing.about",
    path: "/about",
    meta: aboutCHpRmaSGn4pgA6aQ_5Vvi7Y_45G_45mHr0CVzlXeQHo_45_45tEMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/about.vue")
  },
  {
    name: "landing.home",
    path: "/",
    meta: index8pkQesfXpZbfMo_45eZiBFLpXzGGR4GMDU_9tgdQxFTFIMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/index.vue")
  },
  {
    name: "landing.terms",
    path: "/terms",
    meta: termsZtcP6_b4VyoEYiOg9zfmdtvOUL0YObCPOpHeCuj0zOAMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/terms.vue")
  },
  {
    name: "landing.blog",
    path: "/blog",
    meta: indexkVz6G2_B3v9XODpnYVR_45lk4ZemsEwiFlU_tXDX_YWAMMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/blog/index.vue")
  },
  {
    name: "landing.blog.single",
    path: "/blog/:slug()",
    meta: _91slug_93eTcZHo2fnaWD7gXsbCETc8xKOYVjrH_Zcg_45WWzLD_2MMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/blog/[slug].vue")
  },
  {
    name: "supplier.dashboard",
    path: "/panel",
    meta: { ...(indexC9ls9XsVXN52pEbk6ODr6zKZNK0sj_456_1FSKd4auRzMMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/index.vue")
  },
  {
    name: "auth.login",
    path: "/login",
    meta: logine5A7bjdUEHTETAukR7SxsXc4reJ2FLYvqD8NFI_452T7EMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(auth)/login.vue")
  },
  {
    name: "store.cart",
    path: "/cart",
    meta: cart5fwXJ7aNr6CEJptyidVyU8gur5wmC0YEMe0KW8vvceEMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(store)/cart.vue")
  },
  {
    name: "auth.register",
    path: "/register",
    meta: register2kE1NBG8ctXeKdZ_0nRSsrXnx_459m9DwKRwmhrHYTpTcMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(auth)/register.vue")
  },
  {
    name: "store.checkout",
    path: "/checkout",
    meta: checkoutznReYaSU_45fQ2VM1bgJiaxyERfTHJulXJk9wU0fi1BGgMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(store)/checkout.vue")
  },
  {
    name: "store.tracking",
    path: "/tracking",
    meta: trackingUJaGB4pYT3Sc3rMSo14wg3pH_45yG32zQL37Op_45_45OXQScMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(store)/tracking.vue")
  },
  {
    name: "supplier.apps",
    path: "/panel/apps",
    meta: { ...(indexf9fpHsgXZ5PRol25yuadlrlv2BB7icNSY2nZjPzFI4wMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/apps/index.vue")
  },
  {
    name: "payment-callback",
    path: "/payment/callback",
    component: () => import("D:/projects/taminify_com-front/pages/payment/callback.vue")
  },
  {
    name: "admin.dashboard",
    path: "/panel/admin",
    meta: { ...(index1LnX7X3lhJoqiZE2n2xeL_45iEyFqfq7sSIAElZ2uBr_454Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/admin/index.vue")
  },
  {
    name: "warehouse.cart",
    path: "/@:store_slug()/cart",
    meta: cartymIRBQSDs7i2yUc5jDFk8k5OCPqKuNXaYCXsN6TPI78Meta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/cart.vue")
  },
  {
    name: "warehouse.about",
    path: "/@:store_slug()/about",
    meta: about1Q4PUStxJVQxjDdepPiTq6aAsFpGdF97iz0AWyUwLXQMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/about.vue")
  },
  {
    name: "warehouse.home",
    path: "/@:store_slug()",
    meta: indexRkL_jpOdPSzhB0t48Ma0R2a8jhpMvHAqf2rUKYYeYKUMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/index.vue")
  },
  {
    name: "supplier.parcels",
    path: "/panel/parcels",
    meta: { ...(indexlQKb341oLAiGdUqU9vZsUr_45KmElhrV3FD7zWi4RO8sUMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/parcels/index.vue")
  },
  {
    name: "supplier.products",
    path: "/panel/products",
    meta: { ...(index3DgwtIj05NjOOLNvy2UWOr0PqdHhhiX7WfuCKCh_45QIcMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/products/index.vue")
  },
  {
    name: "supplier.settings",
    path: "/panel/settings",
    meta: { ...(indexeNel3I9EAFbXWygIGXPunLAt7EabrPs3eRcGV863eFUMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/settings/index.vue")
  },
  {
    name: "supplier.financial",
    path: "/panel/financial",
    meta: { ...(indexhTqy4pAset4r9k4k_agRPdIqMccRHF4y_459DvLCzar1sMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/financial/index.vue")
  },
  {
    name: "supplier.products.create",
    path: "/panel/products/create",
    meta: { ...(createFshUBTYuNobxQHlRYFBjti8zjc_45R1XyPXzKTymS7jvMMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/products/create.vue")
  },
  {
    name: "warehouse.checkout",
    path: "/@:store_slug()/checkout",
    meta: checkout7PJyPYVdGgHPtmHjPOF6w4R1GRAUd2nreMZPWx7KatsMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/checkout.vue")
  },
  {
    name: "warehouse.tracking",
    path: "/@:store_slug()/tracking",
    meta: trackingbcwMEGXBbCwBqgKQ_45re59WBvPGcqhwBjuBg28_45lZOmsMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/tracking.vue")
  },
  {
    name: "admin.users.list",
    path: "/panel/admin/users",
    meta: { ...(indexzU7mXyDuFAyUG5a_uj3RFdBdXQNXSKdZqNCA_Rrio5UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/admin/users/index.vue")
  },
  {
    name: "store.category",
    path: "/categories",
    meta: index6sTidBAFWYmUx0fk58WsyRXnlxUOmIIraDZcIhAVvCUMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(store)/categories/index.vue")
  },
  {
    name: "supplier.products.edit",
    path: "/panel/products/:id()/edit",
    meta: { ...(edit18y4TUANn76i_45L5dt17SiC9wReVbXX_450L57CJbGNghcMeta || {}), ...{"middleware":["auth","warehouse-completed"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/products/[id]/edit.vue")
  },
  {
    name: "admin.products.list",
    path: "/panel/admin/products",
    meta: { ...(index6Eu_45d1WFjPWtC4Wb_s1zxolg4Uho2K30XOoPtxNmrcwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/admin/products/index.vue")
  },
  {
    name: "warehouse.tracking-by-id",
    path: "/@:store_slug()/tracking-by-id",
    meta: tracking_45by_45idH3Krkf62gmeNafZB98eRY46MJGJv3b_aFGeenv7ncI8Meta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/tracking-by-id.vue")
  },
  {
    name: "store.product",
    path: "/products/:product_id()",
    meta: _91product_id_93g1FxPjKuIGC699KMXIJblDxr9dP3sEWEfnOikMIgV2gMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(store)/products/[product_id].vue")
  },
  {
    name: "warehouse.category",
    path: "/@:store_slug()/categories",
    meta: indexZShFXiCNBXpZpon3rX_45uAWlfRdoEHEyB4RSGOtVdM0cMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/categories/index.vue")
  },
  {
    name: "admin.products.edit",
    path: "/panel/admin/products/:id()/edit",
    meta: { ...(edit_45bzGr5b4f_J6rDJ_454JHjHPObn_ORyEUh7yzmCZ4u0ygMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/admin/products/[id]/edit.vue")
  },
  {
    name: "store.category.single",
    path: "/categories/:category_slug()",
    meta: _91category_slug_93mO6DIST_eafMIfy6ijPmBUrXLvmsNCn5_NKSmvj_K6MMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/(store)/categories/[category_slug].vue")
  },
  {
    name: "warehouse.product",
    path: "/@:store_slug()/products/:product_id()",
    meta: _91product_id_9320fcrgbmZm3U2JV6RUIMxRzi1IstE6BU_GZthFmnDosMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/products/[product_id].vue")
  },
  {
    name: "admin.withdraw-requests.list",
    path: "/panel/admin/withdraw-requests",
    meta: { ...(indexrOlG6o0VmHBxBemN1oyFiVcTZvOhsPbXc729O60AAygMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/projects/taminify_com-front/pages/panel/admin/withdraw-requests/index.vue")
  },
  {
    name: "warehouse.category.single",
    path: "/@:store_slug()/categories/:category_slug()",
    meta: _91category_slug_93F9HXGA_veT_BK8JnOHqXK3J_qplElyuHsIX_45eSzunRYMeta || {},
    component: () => import("D:/projects/taminify_com-front/pages/@[store_slug]/categories/[category_slug].vue")
  },
  {
    name: component_45stubtwoC70oqQBff71ecTajfXw3oAHpyDCPqKtTCWBCKAxQMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubtwoC70oqQBff71ecTajfXw3oAHpyDCPqKtTCWBCKAxQ
  }
]